<template>
  <template v-if="relevantTopic">
    <template v-if="faIcon">
      <!-- visualisierung via icons-->
      <div aria-hidden="true">
        <span
          class="help-trigger mx-2"
          :title="domainStore.translate('discuss.thought.voting.weighted.show-help')"
          @click="toggleWeightedHelpText"
          v-if="weightedPointsHelpText && weightedPointsHelpText != ''"
        >
          <font-awesome-icon icon="question-circle" size="lg" />
        </span>
        <span>
          <strong>{{ domainStore.translate('discuss.thought.voting.weighted.weight') }}&nbsp;&nbsp;</strong>
        </span>
        <span v-for="(n, index) in thought.vote_weight" :key="index" class="thought_vote_weight-icon">
          <font-awesome-layers>
            <font-awesome-icon :icon="faIcon" />
          </font-awesome-layers>
        </span>
        <Message
          v-if="weightedPointsHelpText && weightedPointsHelpText != ''"
          v-show="shouldShowWeightedHelpText"
          closable
          severity="info"
          role="alert"
          class="mb-2"
          @close="toggleWeightedHelpText"
        >
          <span v-dompurify-html="weightedPointsHelpText"></span>
        </Message>
      </div>
      <span class="visually-hidden">
        {{ domainStore.translate('discuss.thought.voting.weighted.weight') }} {{ thought.vote_weight }}
        {{ weightedPointsWord }}
      </span>
    </template>
    <template v-else>
      <!-- only text visualisierung -->
      <div>
        <span>
          {{ domainStore.translate('discuss.thought.voting.weighted.weight') }} {{ thought.vote_weight }}
          {{ weightedPointsWord }}
        </span>
      </div>
    </template>
  </template>
</template>
<script>
import Message from 'primevue/message';
import { computed, onMounted, watch } from '@vue/runtime-core';
import { userStore } from '@/store/user-store';
import { projectStore } from '@/store/project-store';
import { domainStore } from '@/store/domain-store';
import useToggler from '@/composables/general/useToggler';
export default {
  name: 'thought-vote-weight',

  props: {
    topic: {
      required: true,
      type: Object,
    },
    thought: {
      required: true,
      type: Object,
    },
  },
  components: {
    Message,
  },
  setup(props, context) {
    const { toggleValue: shouldShowWeightedHelpText, toggle: toggleWeightedHelpText } = useToggler();

    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });

    const relevantTopic = computed(() => {
      if (props.topic.votetype == 'weighted_support') {
        return props.topic;
      }
    });
    const project = computed(() => {
      return projectStore.getState().project;
    });
    const faIcon = computed(() => {
      if (project.value && project.value.config?.weighted_support_icon) {
        return project.value.config?.weighted_support_icon;
      }
      return null;
    });
    const weightedPointsWord = computed(() => {
      if (project.value && project.value.config?.weighted_support_word) {
        return project.value.config.weighted_support_word;
      }
      return 'Punkte';
    });
    const weightedPointsHelpText = computed(() => {
      if (project.value && project.value.config?.weighted_support_helptext) {
        return project.value.config.weighted_support_helptext;
      }
      return '';
    });

    return {
      domainStore,
      // computed
      shouldShowWeightedHelpText,
      isLoggedIn,
      relevantTopic,
      faIcon,
      weightedPointsWord,
      weightedPointsHelpText,
      toggleWeightedHelpText,
    };
  },
};
</script>
<style scoped lang="scss">
.thought_vote_weight-icon {
  padding-right: 0.3rem;
  font-size: 1.4rem;
  &.used {
    color: grey;
  }
  &.available {
    color: green;
  }
}
</style>
